import type { ReactNode } from 'react';
import { Box, type SxProps, type Theme } from '@mui/material';

const DEFAULT_WIDTH = '50%';
const DURATION = '0.3s';

export type ExpandingPaneProps = {
  expanded: boolean;
  width?: string;
  children: ReactNode;
  sx?: SxProps<Theme>;
};

/**
 * Horizontal panel that animates open/closed via width and opacity. Children
 * stay mounted; the pane is inert while collapsed.
 */
const ExpandingPane = ({
  expanded,
  width = DEFAULT_WIDTH,
  children,
  sx,
}: ExpandingPaneProps) => (
  <Box
    inert={!expanded}
    sx={[
      {
        flexShrink: 0,
        width: expanded ? width : 0,
        minWidth: 0,
        alignSelf: 'stretch',
        opacity: expanded ? 1 : 0,
        overflow: 'clip',
        transition: `width ${DURATION} ease-in-out, opacity ${DURATION} ease-in-out`,
      },
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  >
    {children}
  </Box>
);

export default ExpandingPane;
